// extracted by mini-css-extract-plugin
export default {"productGrid":"BZ-z","centerLink":"CZ-z","productSection":"DZ-z","item":"EZ-z","ctaButton":"FZ-z"};